import React from "react";
import { useSelector } from "react-redux";
import HomeScreen from "../screens/HomeScreen";
import NewHomeScreen from "../screens/NewHomeScreen";

const RoleBasedHomeScreen = () => {
  const userInfo = useSelector((state) => state.auth.userInfo);

  if (!userInfo) return <div>Loading...</div>;

  const roleId = Number(userInfo.role);
  if(roleId==1)
  {
    return <HomeScreen/>
  }
  else
  {
    return <NewHomeScreen/>
  }
};

export default RoleBasedHomeScreen;
